import { render, staticRenderFns } from "./_AccessControl.vue?vue&type=template&id=4063b162&"
import script from "./_AccessControl.vue?vue&type=script&lang=ts&"
export * from "./_AccessControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports